import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#2D2D2D] text-white py-12" data-id="element-117">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-118">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-119">
          {/* Logo and Description */}
          <div data-id="element-120">
            <div className="mb-4" data-id="element-121">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5fdks2cGhDUMK6NuADkmoG/logo-footer.png" alt="ArrendaLogic" className="h-12 w-auto" data-id="element-122" />
            </div>
            <p className="text-gray-400 text-sm" data-id="element-123">
              Especialistas en Arrendamientos de Transporte, Maquinaria y
              Equipo.
            </p>
          </div>

          {/* Contact Info */}
          <div data-id="element-124">
            <h4 className="text-lg font-bold mb-4" data-id="element-125">Contacto</h4>
            <div className="space-y-3" data-id="element-126">
              <div className="flex items-start space-x-3" data-id="element-127">
                <PhoneIcon size={18} className="text-[#1da4dd] mt-1" data-id="element-128" />
                <span className="text-gray-400 text-sm" data-id="element-129">
                  +52 (55) 1234-5678
                </span>
              </div>
              <div className="flex items-start space-x-3" data-id="element-130">
                <MailIcon size={18} className="text-[#1da4dd] mt-1" data-id="element-131" />
                <span className="text-gray-400 text-sm" data-id="element-132">
                  contacto@arrendalogic.com
                </span>
              </div>
              <div className="flex items-start space-x-3" data-id="element-133">
                <MapPinIcon size={18} className="text-[#1da4dd] mt-1" data-id="element-134" />
                <span className="text-gray-400 text-sm" data-id="element-135">
                  Ciudad de México, México
                </span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-136">
            <h4 className="text-lg font-bold mb-4" data-id="element-137">Enlaces Rápidos</h4>
            <ul className="space-y-2" data-id="element-138">
              <li data-id="element-139">
                <a href="#inicio" className="text-gray-400 hover:text-[#1da4dd] text-sm" data-id="element-140">
                  Inicio
                </a>
              </li>
              <li data-id="element-141">
                <a href="#acerca" className="text-gray-400 hover:text-[#1da4dd] text-sm" data-id="element-142">
                  Acerca
                </a>
              </li>
              <li data-id="element-143">
                <a href="#servicios" className="text-gray-400 hover:text-[#1da4dd] text-sm" data-id="element-144">
                  Servicios
                </a>
              </li>
              <li data-id="element-145">
                <a href="#porque" className="text-gray-400 hover:text-[#1da4dd] text-sm" data-id="element-146">
                  ¿Por qué arrendar?
                </a>
              </li>
              <li data-id="element-147">
                <a href="#contacto" className="text-gray-400 hover:text-[#1da4dd] text-sm" data-id="element-148">
                  Contacto
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 text-center" data-id="element-149">
          <p className="text-gray-400 text-sm" data-id="element-150">
            © 2024 Arrenda Logic. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}